// extracted by mini-css-extract-plugin
export default {"title":"kYiJE746PF","explanation":"FxWTHANrdN","buttonContainer":"eFFa1Dxmsv","skipButton":"bCwN4MwuY8"};